import { render, staticRenderFns } from "./after_detail.vue?vue&type=template&id=454e7511&scoped=true"
import script from "./after_detail.vue?vue&type=script&lang=ts"
export * from "./after_detail.vue?vue&type=script&lang=ts"
import style0 from "./after_detail.vue?vue&type=style&index=0&id=454e7511&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454e7511",
  null
  
)

export default component.exports